import * as React from "react";

import { IconSvgProps } from "@/types";

export const Logo: React.FC<IconSvgProps> = ({
  size = 60,
  width,
  height,
  ...props
}) => (
  <svg
    height={size || height}
    viewBox="0 0 439 440"
    width={size || width}
  >
    <path d="M141.5 13.4c-3.3.8-9.6 2.6-14 4.1-4.4 1.4-12.3 3.7-17.5 5s-15.3 4-22.5 5.9c-7.1 2-16.1 4.3-20 5.2-11.8 2.7-27.8 7.6-32.5 9.9-7.8 3.9-8.5 5.4-8.3 15.8.4 15.5 4.9 26.6 19.6 48.4 13.8 20.4 14.8 22.7 16.8 38.4 1.1 9.1 2.9 14.2 6.2 17.7 3 3.3 9 6.2 12.6 6.2 4.5 0 12.2-3.2 17.6-7.4 7.2-5.5 8.5-4.8 8.5 4.7.1 12 6.9 28.7 17.6 43.4 5.1 6.9 6.1 9 5.4 10.7-.4 1.1-1.9 4.6-3.3 7.6-1.3 3-3.2 7.9-4.1 10.7-1 2.9-3.9 9.3-6.6 14.2-11.9 21.8-14.7 43.1-8.6 65.6 4.6 17.2 6 19.8 25.1 44 19 24 37.7 44.5 40.8 44.5 1.7 0 1.4-.8-1.8-6.8-2-3.7-5.9-10-8.6-14-2.7-3.9-4.6-7.2-4.2-7.2.7 0 7 4.1 11.3 7.5 6.2 4.8 19.7 19.6 21.8 23.9 1.3 2.6 2.8 7.3 3.3 10.4 1.8 11.7 2.2 13.2 2.9 13.2.4 0 1.9-1.5 3.4-3.4 5.6-7.4 21.1-21.9 29.6-27.6 1.9-1.3 11.2-8.1 20.5-15 9.4-7 18.3-13.5 19.9-14.5l2.9-1.9-1.3 2.4c-.7 1.4-4.1 6.1-7.5 10.5-7.7 10-9.1 12.5-7.1 12.5 1.7 0 23.2-22.7 31.3-33 8.3-10.7 10.8-14.6 14.4-22.5 11.3-25 10.3-46.8-3.4-74l-4-8 1.7-8.5c.9-4.7 1.9-11.4 2.3-15 .5-5.4 1.1-7.1 3.7-10 5.6-6.2 12.8-18 15.7-25.6 4.9-12.4 6.1-18.3 7.7-35.9 1.2-14.2 1.7-17.4 3.4-19.2 2.5-2.6 5.4-3.5 6.7-1.9 1.1 1.4 2.6 10.1 4 24.6.6 5.2 1.7 12.5 2.5 16.2 1.8 7.6 9.9 24.6 12.2 25.5 4.2 1.6 9-4.1 18.2-21.7 2.5-4.7 8.2-14.2 12.8-21.1 4.6-7 9.6-15.3 11-18.5 1.4-3.3 3.1-6.9 3.7-8.2 1.6-3.3 1.5-12.6-.2-14.5-.7-.9-7.1-5.3-14.3-9.8-16.3-10.3-21.9-14.9-29.3-24-3.3-4.1-8.1-9.8-10.7-12.7-5.3-5.9-5.8-7.2-2.7-7.2 3.8 0 1.6-3.4-4.3-6.4-4.4-2.2-7.6-3-13.5-3.4-5.5-.3-8.5-1-10.2-2.3-3.4-2.7-6.6-2.4-14.4 1.7-4.2 2.2-7.8 3.4-9.1 3.1-1.1-.3-9.9-3.7-19.3-7.6-19.5-7.9-24.5-9.4-39.3-11.5-9.8-1.4-38.5-3.6-47.5-3.6-3.4 0-4.5-.7-9.5-5.8-3.1-3.1-7.6-8.9-10.2-12.8-2.5-3.9-6-8.1-7.8-9.4-4.1-2.9-11.2-3.5-19.5-1.6m47.8 36.7c2.6.5 7.8.9 11.5.9 8.2 0 34.2 3.4 43.2 5.6 8.7 2.1 34.6 10.9 44.2 14.9 7.1 3 13.6 7.1 13.7 8.7.1.3-3.1-.5-7-1.8S287 76 286.1 76s-2.1-.4-2.6-.9c-.6-.4-2.2-1.1-3.7-1.5-2.2-.5-3.1-.1-4.4 1.9-2 3-3 3.2-3.7.5-.3-1.1-1-2-1.6-2-.7 0-1.1 4-1.1 12 0 10.4-.5 14-3.6 26.8-3.5 14.4-3.6 15-3 28.2.7 14.1 2.4 25.6 5.2 35 3 10.3 3 10-.2 10-1.6 0-5.8-1-9.4-2.1-8.3-2.6-26-3.7-31.4-1.9-8.5 2.8-15.6 12.6-15.6 21.3 0 6.6 3.3 18.4 6.6 23.8 2.7 4.3 10.6 11.4 15.5 13.9 5.1 2.6 6.1 4.3 5.4 8.3-.9 4.6-3.7 7-11 9.5-9.6 3.3-13.4 4.2-24.6 5.7-9.3 1.2-11.2 1.2-16.3-.1-10.3-2.7-16.1-7.9-23-20.5-6.1-11.4-7.4-20.2-5-33.7.5-2.6.3-3.1-.9-2.6-.8.3-1.7 1.4-2 2.5-.5 2-2.7 2.7-2.7.9s7.8-11.8 11.2-14.3c1.8-1.4 4.8-3.2 6.6-4.2 4-2 3.6-3-.7-2-4.8 1-14.3 8.7-20.5 16.4-3.9 4.8-6.4 7.1-7.8 7.1-3.3 0-12.5-10.1-15.9-17.4-6.1-13-7-38.3-1.8-52.1 4.2-11.3 12.8-18.5 21.9-18.5 3.8 0 4.2.3 7.6 5.6 8.1 12.6 26.8 18.8 39 12.8 3-1.5 4.6-3.3 7.1-8.2 5.2-10.2 5.2-19 .1-28.6-2.5-4.8-10.3-8.5-17.5-8.6-4.8 0-7.1 1.2-4.1 2.2 2.1.7-.1 2.6-3.9 3.3-2.1.3-6.2 2-9 3.6-6.3 3.5-6.3 3.5-6.3.9 0-3.2-3.4-.9-6.2 4.2-2.9 5.3-5.7 7.3-14.2 10.2-10.6 3.7-12.1 2-9.3-10.3 1-4.6 2.3-6.7 7.2-12 3.3-3.5 11.3-13.4 17.7-22 11.2-14.8 11.7-15.8 11.8-20.4 0-4.7.1-4.8 4.5-6.8 2.5-1.1 4.5-2.4 4.5-2.8 0-.9 6.9-.5 14.3 1M290 211.7c7.2 27.7 5.1 44.9-6.7 57.4-7.8 8.3-13.8 9.7-22.2 5.5-7.1-3.7-10.7-7.1-13.6-13l-2.6-5.3 1.8-4.9c1.6-4.2 2.3-4.9 4.8-5.2 9.3-.8 19.6-5.3 24.2-10.5 4.4-5 9-16.9 9.8-25.5.4-3.9 1.1-7.2 1.5-7.2s1.8 3.9 3 8.7M145.7 230c6.2 3.7 6.8 4.4 9.8 11.3 7.4 17 19 29.2 30.5 32 1.4.4 5.3 3.3 8.8 6.6 3.4 3.3 8.4 7 11.2 8.2 5.5 2.5 5.6 3.9.4 3.9-1.9 0-3.4.4-3.4.9 0 1.6 7.1 2.2 18.9 1.5 16.2-.9 16.9 1.2 2.4 7.1-8.3 3.4-8.2 4.9.3 4 8.8-.9 17.7-5 22.9-10.4 3.7-3.8 10.8-7.1 12.3-5.7.6.7-1.2 4.6-4.9 10.8-6.5 10.8 6.8.9 17.3-13 4-5.1 5.3-6.2 7.7-6.2 2.2 0 3.6.8 5.1 3 2.7 3.8 4.3 3 3.4-1.7-.6-3-.4-3.4 1.1-3.1 1 .1 2.5 2.2 3.4 4.5 2.2 5.6 4.1 7.6 4.1 4.2 0-2.9-1.7-9.6-3.2-12.6-1.2-2.4-.4-4.3 1.1-2.7.5.5 1.9 3.8 3.2 7.4 1.8 5.1 2.3 9.3 2.6 20 .4 12 .1 14.6-2.1 23.4-2.4 9.3-7.5 20.3-8.3 17.9-.2-.6.7-5.3 2.1-10.5 2.7-10.1 3.7-20 2.1-20.8-.5-.3-1.4 1.3-1.9 3.5-1.5 7.3-7.7 25.8-10.3 30.9-6.7 13.2-13.7 20.8-32.2 34.8-5.3 4-12.1 9.3-15.1 11.7-7.2 5.7-25.7 23.9-29.5 29-1.7 2.2-3.3 4.1-3.7 4.1-1.3 0-.9-3.4.9-8.9 1.5-4.7 1.9-5.1 4.7-5.1 2.6 0 4.5-1.3 10.4-7.3 6.1-6.2 7.5-8.2 8.7-12.7 2.3-8.7.5-8.4-9 1.6-7.4 7.6-8.6 8.5-8.2 6.2.6-3.8-2.2-3.7-5.6.2-1.5 1.6-3.1 3-3.6 3s-1.6-3.9-2.5-8.8c-4.6-23.8-7.7-31.7-16.4-41.3-4.3-4.8-12.7-10.7-13.8-9.6-.3.2 1.4 2 3.7 3.8 7.6 6 14.2 16.3 17.4 26.9 1.5 4.8 2.3 16.6 1.2 17.7-.8.7-3.7-1.3-21.9-15.3-7.8-6.1-17-12.8-20.3-15-13.2-8.7-22.9-20.3-27.3-32.8-4.8-13.8-5.5-18-5.6-32.6 0-14.3 0-14.6 3.6-23.8 2-5.2 3.9-9.6 4.2-10 1.1-1 2 .8 2.7 5.6.4 2.6 1.3 6.7 1.9 9.2s1.4 6 1.7 7.8c1 6.4 2.4 4.4 1.6-2.5-1.3-10.9-.7-35.1 1-41.5 1.2-4.7 5.9-12.8 7.4-12.8.2 0 3.4 1.8 7 4m97.2 39.1c1.8 2.2 5.2 5.4 7.5 7 2.2 1.7 4.1 3.5 4.1 4.1 0 3.3-18.9 5.7-30.4 3.9-11.2-1.8-26.1-8.5-23.8-10.8.4-.3 3.9-.9 7.9-1.4 7.8-.8 9.1-1.1 18.3-3.9 5.3-1.7 8.4-2.4 12.1-2.9.6 0 2.5 1.7 4.3 4"
     fill="currentColor"/>
    <path d="M155.3 267.6c.3 1.1.8 4.4 1.2 7.4 2.1 18.1 16.5 40.5 30 46.6 7 3.2 9 2.2 3.5-1.8-7.1-5.3-16.1-19.6-19.5-31.1-2-6.8-3.5-8.2-3.5-3.2 0 2.2-.4 3.4-1 3-1.6-1-4.6-7.4-7-14.8-1.2-3.7-2.6-7-3.2-7.3-.6-.4-.8.1-.5 1.2M133.1 331.7c6.4 11.8 10.1 15.6 24.1 25.1 7.3 4.9 15.3 10.6 17.7 12.6s4.6 3.4 4.9 3.2c.7-.8-4.2-7.9-8.1-11.8-1.8-1.8-6.5-5.2-10.4-7.5-10.3-6.2-16.2-11.2-23.3-19.7-3.4-4.2-6.7-7.6-7.2-7.6s.6 2.6 2.3 5.7"
     fill="currentColor"/>
  </svg>
);

export const OpendoorIcon = (props: IconSvgProps) => (
  <svg
    width="800px"
    height="800px"
    viewBox="0 -0.5 17 17"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    className="si-glyph si-glyph-door"
    {...props}
  >
    <title>{"1144"}</title>
    <defs />
    <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
      <g transform="translate(4.000000, 0.000000)" fill="currentColor">
        <path
          d="M0.083,0.041 L7.042,2.708 L7.042,14.792 L0.333,13.083 L0.125,13.917 L7.928,15.917 L7.928,13.875 L9.896,13.874 L9.896,0.041 L0.083,0.041 Z"
          className="si-glyph-fill"
        />
        <rect
          x={5}
          y={8}
          width={0.875}
          height={0.875}
          className="si-glyph-fill"
        />
      </g>
    </g>
  </svg>
);


export const VerticalDotsIcon = ({size = 24, width, height, ...props}: IconSvgProps) => {
  return (
    <svg
      aria-hidden="true"
      fill="none"
      focusable="false"
      height={size || height}
      role="presentation"
      viewBox="0 0 24 24"
      width={size || width}
      {...props}
    >
      <path
        d="M12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
        fill="currentColor"
      />
    </svg>
  );
};

export const SearchIcon = (props: IconSvgProps) => {
  return (
    <svg
      aria-hidden="true"
      fill="none"
      focusable="false"
      height="1em"
      role="presentation"
      viewBox="0 0 24 24"
      width="1em"
      {...props}
    >
      <path
        d="M11.5 21C16.7467 21 21 16.7467 21 11.5C21 6.25329 16.7467 2 11.5 2C6.25329 2 2 6.25329 2 11.5C2 16.7467 6.25329 21 11.5 21Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M22 22L20 20"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  );
};